import { ConnectLoaderWrapper, NormalIconWrapper, WalletButtonStyled } from './ConnectWallet.styled'
import type { IconKey } from '@rhinofi/dvf-shared-ui'
import { Icon, IconSizes, Text, TextSize } from '@rhinofi/dvf-shared-ui'
import { SmallSpinner } from '../common/Helpers/SmallSpinner'
import { FlexContainer } from '../common/Wrappers/Containers'

type WalletButtonProps = {
  isConnecting: boolean
  isDetected?: boolean
  disabled?: boolean
  onClick: () => void
  label: string
  image?: string | undefined
  icon?: IconKey | undefined
  id?: string
  testId?: string
}

export const WalletButton = ({
  isConnecting,
  isDetected,
  image,
  icon,
  disabled,
  label,
  onClick,
  id,
  testId,
}: WalletButtonProps) => (
  <WalletButtonStyled disabled={disabled} onClick={onClick} id={id} data-testid={testId}>
    <div className="wallet-icon-wrapper">
      {isConnecting ? (
        <ConnectLoaderWrapper>
          <SmallSpinner />
        </ConnectLoaderWrapper>
      ) : icon ? (
        <NormalIconWrapper>
          <Icon id={icon} size={IconSizes.Large} />
        </NormalIconWrapper>
      ) : (
        <img className="wallet-icon" src={image} alt="wallet" />
      )}
    </div>
    <FlexContainer $justifyContent="space-between" $fullWidth>
      <Text size={TextSize.S} bold>
        {label}
      </Text>
      {isDetected ? (
        <Text size={TextSize.XS} color="textSecondary" bold>
          Detected
        </Text>
      ) : (
        ''
      )}
    </FlexContainer>
  </WalletButtonStyled>
)
